<template lang="html">
    <div id="email-to-friend">
        <snap-dialog
            class="email-to-friend-dialog"
            :mountPoint="mountPoint"
            :width="750"
            :title="$t('emailToFriendDialog.EmailThisPatent')"
            :onClose="onClose"
        >
            <div slot="body" class="email-friend-dialog-body">
                <div class="email">
                    <span>{{ $t('emailToFriendDialog.Email') }}</span>
                    <div class="close-btn" @click="onClose">
                        <svg class="snap-zen-icon" aria-hidden="true">
                            <use xlink:href="#zen-icon-cross-large" />
                        </svg>
                    </div>
                    <input
                        v-model.trim="otherEmail"
                        :placeholder="$t('emailToFriendDialog.emailPlaceholder')"
                        type="text"
                    >
                </div>
                <div
                    v-if="licenceVisible"
                    :class="{
                        'error': savedFlag && !GdprLicence
                    }"
                    class="GDPR-Licence"
                >
                    <input
                        id="GdprLicence"
                        v-model="GdprLicence"
                        type="checkbox"
                        value="false"
                    >
                    <label for="GdprLicence">{{ $t('app.emailToFriendDialog.GDPR_Licence') }}</label>
                </div>
                <div class="title">
                    <span>{{ $t('emailToFriendDialog.Title') }}</span>
                    <p v-show-ellipsis class="title-content">
                        <span>{{ renderViewDatas.PN }}&nbsp;{{ renderViewDatas.TITLE | escapeHtml }}</span>
                    </p>
                </div>
                <div class="content">
                    <span>{{ $t('emailToFriendDialog.Content') }}</span>
                    <div class="email-content">
                        <div>
                            <div class="email-text-info">
                                <p class="my-email">
                                    {{ myEmail }}
                                    {{ $t('emailToFriendDialog.interest') }}
                                    <a
                                        id="viewlink"
                                        :href="viewLink"
                                    >
                                        {{ viewLink }}
                                    </a>
                                </p>
                            </div>
                            <div class="contain-patent">
                                <p v-if="computedEmpty(renderViewDatas.TITLE)" class="pn-title">
                                    <span>{{ renderViewDatas.PN }}:</span>
                                    <span>{{ renderViewDatas.TITLE | escapeHtml }}</span>
                                </p>
                                <p v-if="computedEmpty(renderViewDatas.APD)">
                                    <span>{{ $t('emailToFriendDialog.Filing') }}:</span>
                                    <span>{{ renderViewDatas.APD }}</span>
                                </p>
                                <p v-if="computedEmpty(renderViewDatas.IN)" class="inventor">
                                    <span>{{ $t('emailToFriendDialog.Inventor') }}:</span>
                                    <span v-for="item in renderViewDatas.IN" :key="item.name" class="name">{{ item.name | escapeHtml }}</span>
                                </p>
                                <p v-if="computedANEmpty(renderViewDatas.ANC)" class="inventor anc">
                                    <span>{{ $t('emailToFriendDialog.ANC') }}:</span>
                                    <span v-for="(item, index) in renderViewDatas.ANC.OFFICIAL" :key="index" class="name">{{ item | escapeHtml }}
                                        <span v-if="showAnName(renderViewDatas, 'ANC', 'EN', index, item)">({{ renderViewDatas['ANC']['EN'][index] | escapeHtml }})</span>
                                    </span>
                                </p>
                                <p>
                                    <span>{{ $t('emailToFriendDialog.moreDetail') }}</span>
                                    <a id="sitelink" :href="siteHost">{{ siteHost }}</a>
                                </p>
                            </div>
                        </div>
                        <div class="patent-img">
                            <img v-if="thumbImg" class="patentimage" :src="thumbImg">
                            <image-loader
                                v-if="imageLoaderData.type==='patsnap'"
                                :item="imageLoaderData.model"
                                :size="{width:148, height:210}"
                                @imageLoaded="thumbImg=''"
                            />
                            <img
                                v-if="imageLoaderData.type==='offical'"
                                :src="imageLoaderData.src"
                                alt=""
                                class="thumb-img"
                                @load="thumbImg=''"
                                @error="isThumbnailError = true"
                            >
                        </div>
                    </div>
                </div>
                <div class="options">
                    <span>{{ $t('emailToFriendDialog.Options') }}</span>
                    <div class="">
                        <p>
                            <input id="contain-patent-pdf" v-model="hasPdf" type="checkbox">
                            <label for="contain-patent-pdf">{{ $t('emailToFriendDialog.original') }}</label>
                        </p>
                        <p v-if="myEmail">
                            <input id="email-to-self" v-model="emailToSelf" type="checkbox">
                            <label for="email-to-self">{{ $t('emailToFriendDialog.myself') }}</label>
                        </p>
                    </div>
                </div>
                <div v-if="submitLoading" class="more-loading">
                    <loading />
                </div>
            </div>
            <div slot="footer">
                <a
                    v-if="!submitLoading"
                    type="submit"
                    class="snap-zen-btn primary emall-to-friend-btn-submit"
                    @click="submit"
                >
                    {{ $t('emailToFriendDialog.Send') }}
                </a>
                <a
                    v-if="submitLoading"
                    disabled="disabled"
                    type="submit"
                    class="snap-zen-btn primary emall-to-friend-btn-submit"
                >
                    {{ $t('emailToFriendDialog.Send') }}
                </a>
                <a type="button" class="snap-zen-btn ml7" @click="onClose">
                    {{ $t('emailToFriendDialog.Cancel') }}
                </a>
            </div>
        </snap-dialog>
    </div>
</template>

<script>
import EmailToFriend from './email-to-friend';

export default EmailToFriend;
</script>
<style lang="scss">
$a-color: #4990e2;

.email-to-friend-dialog {
    .modal-close-btn {
        display: none;
    }
    .more-loading {
        width: 75px;
        height: 50px;
        overflow: hidden;
        position: absolute;
        top: 40%;
        left: 45%;
    }
    .email-alert-dialog-header {
        .zen-info {
            font-size: 16px;
            color: #d2d2d2;
        }
    }
    .email-alert-dialog-body {
        color: #555;

        .el-input__inner:hover {
            border-color: #d2d2d2;
        }
        .query-title {
            margin-bottom: 20px;
            font-size: 14px;
            color: #999;
            position: relative;
            line-height: 23px;
            &.show-ellipsis:after {
                content: '...';
                position: absolute;
                right: 0;
                bottom: -3px;
                width: 28px;
                background: #fff;
                padding-left: 4px;
            }
        }
        .refine {
            background: #f5f5f5;
            margin-bottom: 19px;
            padding: 8px 11px;
            position: relative;
            line-height: 23px;
            box-sizing: content-box;
            &.show-ellipsis:after {
                content: '...';
                position: absolute;
                right: 10px;
                bottom: 4px;
                width: 50px;
                background: #f5f5f5;
                padding-left: 5px;
            }
        }
        .simple {
            .el-select {
                width: 100%;
                margin-bottom: 10px;
            }
            .advanced-link {
                text-align: right;
                cursor: pointer;
                text-decoration: underline;
                color: $a-color;
            }
        }
        .advanced {
            span.left-label {
                display: inline-block;
                width: 107px;
                text-align: left;
                line-height: 36px;
            }
            .frequency {
                overflow: hidden;
                margin-bottom: 10px;
                clear: both;
                .el-select {
                    display: inline-block;
                    width: calc((100% - 130px) / 2);
                    &:first-of-type {
                        margin-right: 13px;
                    }
                }
            }
            .email-title {
                overflow: hidden;
                margin-bottom: 20px;
                .el-select {
                    width: calc(100% - 112px);
                }
                .title-input {
                    display: inline-block;
                    border-radius: 5px;
                    width: calc(100% - 112px);
                    border: 1px solid #d2d2d2;
                    font-size: 12px;
                    padding: 10px 0 10px 10px;
                    height: 100%;
                    line-height: 100%;
                    &:focus {
                        border-color: #75bb00;
                        outline: 0;
                    }
                }
            }
            .send-to {
                margin-bottom: 20px;
                span.left-label {
                    line-height: 1.5em;
                    vertical-align: top;
                }
                .all-email {
                    width: calc(100% - 112px);
                    display: inline-block;
                    .snap-auto-complete.other-email {
                        margin: 4px 0 0 0;
                    }
                }
            }
            .alert-no-update {
                margin-left: 111px;
            }
        }
    }

    .email-friend-dialog-body {
        color: #555;
        font-size: 14px;
        span {
            width: 70px;
            float: left;
        }
        .close-btn {
            position: absolute;
            top: 14px;
            right: 30px;
            cursor: pointer;
            z-index: 1;
            svg {
                width: 25px;
                height: 25px;
                color: #999;
                cursor: pointer;
            }
        }
        .email {
            padding-bottom: 10px;
            & > span {
                line-height: 36px;
                float: none;
                display: inline-block;
            }
            input {
                width: calc(100% - 79px);
                border-radius: 5px;
                height: 31px;
                line-height: 31px;
            }
            & > div {
                display: inline-block;
                .auto-complete-body {
                    span {
                        float: none;
                    }
                }
            }
        }
        .title {
            overflow: hidden;
            padding-bottom: 10px;
            & > span {
                line-height: 36px;
            }
            .title-content {
                width: calc(100% - 79px);
                float: left;
                vertical-align: top;
                line-height: 36px;
                position: relative;
                padding-left: 6px;
                &.show-ellipsis:after {
                    content: '...';
                    position: absolute;
                    right: 0;
                    bottom: -2px;
                    width: 100px;
                    background: #fff;
                    padding-left: 6px;
                }
                span {
                    width: 100%;
                }
            }
        }
        .content {
            overflow: hidden;
            padding-bottom: 10px;
            .email-content {
                float: left;
                width: calc(100% - 74px);
                vertical-align: top;
                line-height: 21px;
                & > div {
                    float: left;
                    margin-right: 21px;
                    overflow: auto;
                    width: 475px;
                    background: #f5f5f5;
                    padding: 10px;
                    height: 180px;
                    .email-text-info {
                        a {
                            color: $a-color;
                        }
                    }
                    .contain-patent {
                        span {
                            width: auto;
                            float: none !important;
                        }
                        .inventor {
                            .name:after {
                                content: '；';
                            }
                            .name:last-of-type:after {
                                content: '';
                            }
                        }
                    }
                }
                .patent-img {
                    padding: 0;
                    line-height: 177px;
                    background: #fff;
                    float: left;
                    width: 120px;
                    height: 177px;
                    border: 1px solid #d2d2d2;
                    margin-right: 0;
                    overflow: hidden;
                    background-position: center;
                    background-size: contain;
                    background-repeat: no-repeat;
                    img {
                        display: inline;
                        width: 100%;
                        vertical-align: middle;
                        max-height: 100%;
                    }
                }
            }
        }
        .options {
            overflow: hidden;
            & > div {
                float: left;
                vertical-align: top;
            }
            span {
                line-height: 21px;
            }
            p {
                display: flex;
                align-items: center;
                line-height: 21px;
                input[type='checkbox'] {
                    vertical-align: middle;
                    margin-right: 4px;
                    // margin-top: -1px;
                }
            }
        }
    }
    .modal-footer {
        button {
            border: none;
        }
        button[type='submit'] {
            border-color: #75bb00;
            color: #fff;
            background-color: #75bb00;
        }
        button[type='submit']:active {
            border-color: #62981a;
            background-color: #62981a;
        }
        button[type='submit']:hover {
            border-color: #85bf2e;
            background-color: #85bf2e;
        }
        .emall-to-friend-btn-submit {
            position: relative;
            // .loading-mask{
            //   position: absolute;
            //   background: rgba(255,255,255,0.3);
            //   top: 0;
            //   width: 100%;
            //   height: 100%;
            // }
        }
    }
    .GDPR-Licence {
        background: #f5f5f5;
        border-radius: 3px;
        margin-bottom: 10px;
        margin-left: 72px;
        padding: 0px 9px;
        color: #999;
        line-height: 21px;
        input {
            vertical-align: middle;
        }
    }
    .GDPR-Licence.error {
        background: #fbeeee;
        border: 1px solid #edcbcb;
        color: #9f2212;
    }
}
.email-to-friend-dialog #sitelink {
    color: #4990e2;
}
.ml7 {
    margin-left: 7px;
}
</style>
